// extracted by mini-css-extract-plugin
export var badge = "cart-button-module--badge--50aae";
export var cartButton = "cart-button-module--cartButton--9b82d";
export var cartText = "cart-button-module--cartText--8d836";